<template>
  <div class="pageBg">
    <!-- <div style="height:10px;"></div> -->
    <div class="Imgitem">
      <img src="static/image/img-about-us.png" class="imgitemStyle" />
    </div>
    <!-- <div class="crowdFunding">
      <div><span style="font-size:22px;color:#000;font-weight: bold;margin-right:10px;">众筹进展</span><span style="margin-right:10px;">每周日更新进度</span><span>上次更新时间为2021/3/10 22:30</span></div>
      <div style="width:35%;margin-top:10px;"><Progress :percent="percentData" :stroke-width="30" status="active" text-inside /></div>
      
    </div>
    <el-progress :text-inside="true" :stroke-width="26" :percentage="percentData"></el-progress> -->
    <div class="aboutView">
      <div class="Imgitem">
        <img src="static/image/icon-logo-xl.png" class="ImgitemStyle" />
      </div>
      <div class="Imgitem">
        <row type="flex" justify="space-around" class="rowContext">
          <i-col :xs="24" :sm="5" class="colTitle">
            <h1>关于我们</h1>
            <div>About us</div>
          </i-col>
          <i-col :xs="24" :sm="18" class="colContext">
            广州万灵数据有限公司,寓意人为万物之灵,人与数据的结合正是“人人都是数据分析师”的宗旨所向;同时万灵数据寄托着让亿万数据更为灵活使用,让用户操控数据更为随心所欲,人能尽其オ,数据尽其用的愿望。公司核心成员有来自于
            Teradata、阿里巴巴、腾讯、华为等大型互联网企业,目前技术团队拥有工程师12名,其中本科8名,硕士4名,博士1名,截至目前公司拥有高水平国家专利5项,计算机软件著作权7项,商标9项等。
          </i-col>
        </row>
      </div>
      <div class="Imgitem">
        <row type="flex" justify="space-around" class="rowContext">
          <i-col :xs="24" :sm="5" class="colTitle">
            <h1>主要业务</h1>
            <div>Main business</div>
          </i-col>
          <i-col :xs="24" :sm="18" class="colContext">
            <div>
              基于数据科学、人工智能等先进技术,研发惠及各行业客户的数据管理及分析应用解決方案,协助客户掌握数据分析能力,引导客户数据运营,让数据成为生产力。
              公司主要面向高校、金融、医疗、航空、政府、传统实业等行业,开展以下业务:
            </div>
            <br />
            <div>
              1.数据分析基础软件服务自研全国首家一站式、低门槛单机端数据科学平台,致力于解决人们想要快速上手并实践数据分祈,同时兼顾工作效率的问题.
            </div>
            <div>
              2.数据挖掘应用服务通过产品解决方案和专业咨询服务,为各行业客户提供基于场景的定制化数据分析、挖掘服务和应用设计开发服务。
            </div>
            <div>
              3.大数据规划建设服务提供企业级大数据平台、架构規划咨询及建设实施服务,协助企业构建大数据生态体系。
            </div>
          </i-col>
        </row>
      </div>

      <!-- <Row style="margin-top:10px;">
        <Col span="10" style="padding: 20px 10px;"> -->
          <div class="Imgitem">
            <row type="flex" justify="center" class="rowContext">
              <i-col span="24" class="colContextImg">
                <img src="static/image/img-about-us.jpg" class="imgStyle" />
                <Divider>团队与倪光南院士合照</Divider>
              </i-col>
            </row>
          </div>
          <div class="Imgitem">
            <row type="flex" justify="center" class="rowContext fontStyle">
              <i-col span="24" class="colContextImg">
                <div class="colContextImg">
                  MPai的思维创新与出发点非常好，希望你们不忘初心，坚持下去！
                </div>
                <div class="colFather">
                  <div class="colContextRight">
                    —— 倪光南
                  </div>
                  <div class="colContextSmall">
                    中国工程院院士
                  </div>
                  <div class="colContextSmall">
                    前联想集团总工程师
                  </div>
                </div>
              </i-col>
            </row>
          </div>
        <!-- </Col> -->
        <!-- <Col span="14">
          <div class="devSpeaking">
            <h2 style="text-align:center;margin-bottom:10px;">开发者的话</h2>
            <p>开发者是一名重度数据科学迷，在看到Matlab被禁，国内没有数据分析基础工具，因此萌发了自己研发一款数据分析基础工具，也希望把工作中积累的数据分析模板分享给大家，让大家能快速地学会使用数据分析模型。</p>
            <p>规划中的MPAI拥有在线自动绘图，可视化编程与0编程工具箱，花费了全部积蓄后只研发出来0编程工具箱【也就是如今的MPAI】，如今每个月连服务器费用与维护费用都<span style="color:red;">入不敷出</span>，更别说更新软件的资金了，如今开发者仍在补贴工资支持MPAI的更新。</p>
            <p>年初有一家线上培训公司开价300W收购MPAI，但是他们打算将MPai私有化，与我开发的初心相违，因此<span style="color:red;">拒绝了该收购</span>，同时由于开发MPai工具箱版本负债累累，实在负担不起服务器费用与运维更新成本、开发者向各位数据科学爱好者发起众筹，累计达有5K【买断付费用户】，<span style="color:red;">MPai将开源全部代码，众筹情况将在官网更新</span>，资金用于偿还开发债务（40%）与服务器运维（60%），若有剩余资金将着手开发在线自动绘图板块功能（拖入数据自动生成美观图表）与可视化编程板块功能（类似Matlab支持编程），希望大家支持一下无盈利目的的国产数据分析工具MPAI，让MPai向人人都能成为数据分析的目标有继续向下的动力。</p>
            <p>尽管MPai面临的困境重重，但是开发者还是会保持初心，继续不断完善功能，大家可以加q群139397496私聊群主，发送想要mpai扩展的模型，到时候按反馈意见优先开发部分新模型。</p>
            <p>希望大家能支持一下MPai，再次感谢大家！</p>
          </div>
        </Col> -->
      <!-- </Row> -->
    </div>
    <!-- <div style="height:10px;"></div> -->
  </div>
</template>
<style lang="scss" scoped>
@import "../../../public/static/style/page.less";
.crowdFunding{
  width: 80%;
  margin: 0 auto;
  height: 100px;
  background-image: url("../../assets/images/topbg.png");
  background-size: 100%;
  background-repeat: no-repeat;
  padding-top: 20px;
  // padding-left: 2%;
  div:nth-child(1){
    color: darkgray;
  }
  
}
.pageBg{
  background-color: #f2f7fc;
}
.aboutView{
  background-color: #fff;
  width: 80%;
  margin: 0 auto;
}
.imgStyle{
  width: 100%;
  text-align: right;
}
.fontStyle{
  font-family: "华文行楷";
  text-align: right;
}
.devSpeaking{
  padding: 20px 30px;
}
p{            
  text-indent: 2em;
  line-height: 2em;
}
</style>
<script>
import axios from "axios";
export default {
  data(){
    return {
      percentData:"",
    }
  },
  methods:{
  
  },
  mounted(){
    let _this =this;
    axios.get('./data.json').then((res)=>{
      console.log("json数据",res.data.percent);
      _this.percentData = res.data.percent;
    })
    .catch(function(error){
      console.log(error);
    })
  }
}
</script>

